import { combineReducers } from 'redux';
import { createForms } from 'react-redux-form';
import { connectRouter } from 'connected-react-router';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { loadingStates } from '../reducers/Rest/loadingStates';
import { emailSettings } from '../reducers/Rest/emailSettings';
import { people } from '../reducers/Api/People';
import { companies } from '../reducers/Api/Company';
import { companySummaries } from '../reducers/Api/CompanySummaries';
import { popover } from '../reducers/Popover';
import { resources } from '../reducers/Api/Resources/index';
import { modals } from '../reducers/modals';
import { user } from '../reducers/Api/User/index';
import { errors } from '../reducers/Api/Errors/errors';
import { resetPassword } from '../reducers/Api/Auth/resetPassword';
import demos from '../reducers/Api/Demo';
import { collapsed } from '../reducers/collapsed';
import { fleetProfiles } from '../reducers/Api/FleetProfiles/index';
import leasingProfiles from '../reducers/Api/LeasingProfiles';
import { leads } from '../reducers/Api/Leads/index';
import { settings } from '../reducers/Settings/Settings';
import { visitActions } from '../reducers/Api/VisitActions/visitActions';
import { address } from '../reducers/Api/Address/index';
import { affiliates } from '../reducers/Api/Affiliates/index';
import agreements from '../reducers/Api/Agreements';
import events from '../reducers/Api/Events';
import meetings from '../reducers/Api/Meeting/meeting';
import communicationsNew from '../reducers/Api/Communications';
import libraryFiles from '../reducers/Api/Files/index';

export default history =>
    combineReducers({
        router: connectRouter(history),
        toastr: toastrReducer,
        companies,
        libraryFiles,
        collapsed,
        //dashboard,
        emailSettings,
        affiliates,
        demos,
        agreements,
        errors,
        fleetProfiles,
        leasingProfiles,
        leads,
        resources,
        companySummaries,
        communications: communicationsNew,
        modals,
        people,
        //schema,
        loadingStates,
        settings,
        popover,
        user,
        resetPassword,
        visitActions,
        address,
        events,
        meetings,
        ...createForms({
            agreementForm: { notSet: true },
            editFieldForm: {
                value: '',
                title: ''
            },
            agreementTermForm: {}
            /*login: {
            emailAddress: process.env.REACT_APP_DEFAULT_USERNAME,
            password: process.env.REACT_APP_DEFAULT_PASSWORD
        }*/
        })
    });
